import type { SVGProps } from 'react';
const DawnFlagTW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-TW_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-TW_svg__a)">
      <path fill="#FE3030" d="M-1.048 17.067h24.095V-1.067H-1.048z" />
      <path fill="#0909B6" d="M-1.048 8.533h12.572v-9.6H-1.048z" />
      <path
        fill="#fff"
        d="M5.762 5.6 4.759 6.73l.077-1.52-1.494.077 1.11-1.02-1.11-1.02 1.494.077-.077-1.52 1.003 1.13 1.002-1.13-.076 1.52 1.493-.078-1.11 1.02 1.11 1.021-1.493-.077.076 1.52z"
      />
    </g>
  </svg>
);
export default DawnFlagTW;
